exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-leave-active[data-v-96970514]{-webkit-transition:.8s cubic-bezier(.93,.02,.19,1);transition:.8s cubic-bezier(.93,.02,.19,1)}.slide-enter-active[data-v-96970514]{-webkit-transition:1s cubic-bezier(0,1,.75,1);transition:1s cubic-bezier(0,1,.75,1)}.slide-enter[data-v-96970514]{-webkit-transform:translate(100%);transform:translate(100%)}.slide-leave-to[data-v-96970514]{-webkit-transform:translate(-100%);transform:translate(-100%)}.cookie-newsletter-subscribed[data-v-96970514]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96970514","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/newsletter-widget/newsletter-widget-root.vue
// module id = m1bF
// module chunks = 0